import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=a5c208c2&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"
import style0 from "./chat.vue?vue&type=style&index=0&id=a5c208c2&lang=scss&scoped=true&"
import style1 from "./chat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c208c2",
  null
  
)

export default component.exports